export enum ViolationRulesSupportedActions {
  Edit = 'edit',
  Reset = 'reset',
}
